import React, {Fragment, type ReactNode} from 'react'

interface Props {
    id: string
    error: string | null | undefined
}

export default function SidebarInputError(
    {
        id,
        error,
    }: Props): ReactNode {
    return (<>
        {error && <p role="alert" className={'mt-2 text-sm text-red-600'} id={id + '-error'} data-qaid={id + '-error'}>
            {error}
        </p>}
    </>)
}
